module.exports = __webpack_public_path__ + "static/media/za.4b07683a.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/za.svg
// module id = 976
// module chunks = 0